exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1avl7{padding-left:0;padding-right:0;background-color:#fff;min-height:80vh}._3YPN-{margin:0 auto;padding-bottom:24px}.i1rFk{padding:36px}._24piu{color:#484848;line-height:24px;margin:0 0 24px;padding:0 15px;font-weight:700}@media screen and (max-width:1170px){._24piu{text-align:center}}", ""]);

// exports
exports.locals = {
	"root": "_1avl7",
	"container": "_3YPN-",
	"contentContainer": "i1rFk",
	"pageContainer": "iwLwU",
	"containerTitle": "_24piu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/home/Home.css
// module id = 2621
// module chunks = 15